import { CSSProperties, ChangeEventHandler, useContext, useState } from "react";
import "./css/TextAreaModule.css";
import QuestContext from "../../../../components/QuestWrapper";
import { useOnboarding } from "../modular/OnboardingContext";

interface TextAreaProps {
    value?: string;
    style?: CSSProperties | undefined;
    onChange?: ChangeEventHandler<HTMLTextAreaElement> | undefined;
    placeholder?: string;
    maxLength?: number;
    required?: boolean;
    className?: string;
    id?: string;
    key?: string | number;
    regexKey?: string | undefined,
    regexMessage?: string,
    textareaErrorStyle?: CSSProperties | undefined;
    textareatext?: string;
    validateInputRegex?: (validated: boolean) => void
}

export const TextAreaModule = ({
    value,
    onChange,
    style,
    placeholder,
    regexKey,
    regexMessage,
    textareaErrorStyle,
    textareatext,
    maxLength,
    required,
    key,
    validateInputRegex = () => { }
}: TextAreaProps) => {
    const { themeManager } = useOnboarding()

    const fallbackPattern = /^.+$/;

    const [isValidTextArea, setIsValidTextArea] = useState(true);

    const isValidRegex = (pattern: string | undefined): boolean => {
        try {
            new RegExp(pattern || '')
            return true;
        } catch {
            return false;
        }
    };

    const textAreaRegex = !regexKey ? fallbackPattern : isValidRegex(regexKey) ? new RegExp(regexKey) : fallbackPattern;

    const validateNumber = (inputValue: string) => {
        if (inputValue) {
            setIsValidTextArea(textAreaRegex.test(inputValue));
            validateInputRegex(textAreaRegex.test(inputValue));
        } else {
            setIsValidTextArea(true);
            validateInputRegex(true);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const inputValue = e.target.value;
        if (!!regexKey) {
            validateNumber(inputValue);
        }
        if (onChange) {
            onChange(e);
        }
    };

    const handleInputBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
        const inputValue = e.target.value;
        if (!!regexKey) {
            validateNumber(inputValue);
        }
    };

    return (
        <>
            <textarea
                className='q_input_textArea'
                value={value}
                onChange={handleInputChange}
                style={{
                    ...style,
                    fontFamily: themeManager?.getFontFamily() || "'Figtree', sans-serif"
                }}
                placeholder={placeholder}
                maxLength={maxLength}
                required={required}
                key={key}
                onBlur={handleInputBlur}
            />
            {(!!regexKey) && !isValidTextArea && (
                <span style={textareaErrorStyle} className="q-input-error-message">
                    {regexMessage || textareatext}
                </span>
            )}
        </>
    );
};
